import { InputLabelProps } from '@mui/material';

import { StyledInputLabel } from './styles';

export type TLabel = InputLabelProps;

export const Label = ({ id, children, error, ...otherProps }: TLabel) => {
  return (
    <StyledInputLabel htmlFor={id} error={error} {...otherProps}>
      {children}
    </StyledInputLabel>
  );
};
